class FaceController {
    constructor($scope, $transitions, $state) {
        "ngInject";
        console.log("face")
        $scope.$state = $state
        $transitions.onFinish({}, () => {
            $('body').scrollTop(0);
        });
    }
}

export default FaceController;



// WEBPACK FOOTER //
// ./src/app/components/face/face.controller.js